import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { X } from "lucide-react";

const DownloadFormatModal = ({ show, onHide, onDownload, selectedRows }) => {
  const [selectedFormat, setSelectedFormat] = useState("normal");
  const [selectedFileType, setSelectedFileType] = useState("csv");

  const handleDownload = () => {
    if (onDownload && selectedRows) {
      onDownload(selectedRows, selectedFormat, selectedFileType);
      onHide();
      // Reset to default values
      setSelectedFormat("normal");
      setSelectedFileType("csv");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header style={{ borderBottom: "1px solid #e5e7eb", padding: "16px 20px" }}>
        <Modal.Title style={{ fontSize: "18px", fontWeight: 600 }}>
          Download Options
        </Modal.Title>
        <button
          onClick={onHide}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <X size={20} />
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: "24px 20px" }}>
        <div style={{ marginBottom: "24px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: 500,
              color: "#374151",
            }}
          >
            Format Type
          </label>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "12px",
                border: `2px solid ${selectedFormat === "normal" ? "#3b82f6" : "#e5e7eb"}`,
                borderRadius: "8px",
                backgroundColor: selectedFormat === "normal" ? "#eff6ff" : "white",
                transition: "all 0.2s",
              }}
            >
              <input
                type="radio"
                name="format"
                value="normal"
                checked={selectedFormat === "normal"}
                onChange={(e) => setSelectedFormat(e.target.value)}
                style={{ marginRight: "12px", cursor: "pointer" }}
              />
              <span style={{ fontSize: "14px", color: "#374151" }}>Normal</span>
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "12px",
                border: `2px solid ${selectedFormat === "line_items" ? "#3b82f6" : "#e5e7eb"}`,
                borderRadius: "8px",
                backgroundColor: selectedFormat === "line_items" ? "#eff6ff" : "white",
                transition: "all 0.2s",
              }}
            >
              <input
                type="radio"
                name="format"
                value="line_items"
                checked={selectedFormat === "line_items"}
                onChange={(e) => setSelectedFormat(e.target.value)}
                style={{ marginRight: "12px", cursor: "pointer" }}
              />
              <span style={{ fontSize: "14px", color: "#374151" }}>Line Items</span>
            </label>
          </div>
        </div>

        <div>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: 500,
              color: "#374151",
            }}
          >
            File Type
          </label>
          <select
            value={selectedFileType}
            onChange={(e) => setSelectedFileType(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "8px",
              border: "1px solid #e5e7eb",
              fontSize: "14px",
              color: "#374151",
              backgroundColor: "white",
              cursor: "pointer",
            }}
          >
            <option value="csv">CSV</option>
          </select>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "1px solid #e5e7eb", padding: "16px 20px" }}>
        <button
          onClick={onHide}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            backgroundColor: "white",
            color: "#374151",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleDownload}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            border: "none",
            borderRadius: "8px",
            backgroundColor: "#3b82f6",
            color: "white",
            cursor: "pointer",
          }}
        >
          Download
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DownloadFormatModal;

